module.exports = __webpack_public_path__ + "files/8652c5d85c3cd7dd405be46924589494.png";